module.exports = __webpack_public_path__ + "img/icon_phone.c69633ee.svg";